import cx from 'classnames';
import { VERIFIED_ORGANIZATION_BADGE } from 'mk/autogenerated/translations/VerifiedOrganizationBadge.d0ed7145babc95b8537b4446fc35295c'
import React from 'react';
import styles from './VerifiedOrganizationBadge.mscss';

interface OwnProps {
    className?: string;
}

type Props = OwnProps;

const VerifiedOrganizationBadge: React.FunctionComponent<Props> = ({ className }) => (
    <span className={cx(styles.VerifiedOrganizationBadge, className)}>
        {VERIFIED_ORGANIZATION_BADGE}
    </span>
);

VerifiedOrganizationBadge.displayName = 'VerifiedOrganizationBadge';

export default React.memo<Props>(VerifiedOrganizationBadge);
